function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import Input from '../Input/Input';
import { Async } from 'react-select';
import s from './IndustryInput.scss';
import { debounce } from 'lodash';
import cx from 'classnames';

var IndustryInput = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(IndustryInput, _PureComponent);

  function IndustryInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "fetchIndustries", debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term, callback) {
        var fetchedIndustries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAutocomplete(term);

              case 2:
                fetchedIndustries = _context.sent;
                callback(null, {
                  options: fetchedIndustries
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 200));

    _defineProperty(_assertThisInitialized(_this), "loadOptions", function (term, callback) {
      _this.fetchIndustries(term, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "getAutocomplete", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term) {
        var industriesFetcher;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                industriesFetcher = _this.props.industriesFetcher;
                return _context2.abrupt("return", industriesFetcher(term));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    return _this;
  }

  var _proto = IndustryInput.prototype;

  _proto.render = function render() {
    var _this2 = this,
        _cx;

    var _this$props = this.props,
        _this$props$placeHold = _this$props.placeHolderText,
        placeHolderText = _this$props$placeHold === void 0 ? '' : _this$props$placeHold,
        _this$props$inputStyl = _this$props.inputStyle,
        inputStyle = _this$props$inputStyl === void 0 ? 'main' : _this$props$inputStyl,
        onIndustryTextChanged = _this$props.onIndustryTextChanged,
        onIndustrySelected = _this$props.onIndustrySelected,
        industryText = _this$props.industryText,
        bng = _this$props.bng;
    var rest = {};

    if (bng) {
      rest.limit = 40;
    }

    return /*#__PURE__*/React.createElement(Async, {
      inputRenderer: function inputRenderer(inputProps) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, /*#__PURE__*/React.createElement(Input, _extends({
          dataAid: "industry-input",
          g: true,
          id: "industryInput",
          placeholder: placeHolderText,
          onChange: function onChange(e) {
            onIndustryTextChanged(e.target.value);
          },
          onFocus: _this2.scrollToInput,
          inputProps: inputProps,
          style: inputStyle,
          text: industryText,
          bng: !!bng
        }, rest)));
      },
      loadOptions: this.loadOptions,
      arrowRenderer: null,
      className: "selectWrapper",
      placeholder: null,
      onChange: onIndustrySelected,
      loadingPlaceholder: false,
      valueKey: "id",
      searchPromptText: "",
      clearable: false,
      openOnClick: false,
      onBlurResetsInput: false,
      filterOptions: false,
      backspaceRemoves: false,
      onCloseResetsInput: false,
      valueRenderer: function valueRenderer() {},
      noResultsText: false,
      labelKey: "label",
      menuContainerStyle: {
        border: 'none',
        boxShadow: '0 1px 3px 0 rgba(31, 79, 113, 0.15)'
      },
      menuStyle: {
        padding: '16px 24px 16px 12px'
      },
      optionClassName: cx(s.option, (_cx = {}, _cx[s.mainPage] = inputStyle === 'main', _cx))
    });
  };

  return IndustryInput;
}(PureComponent);

export default IndustryInput;